import React from "react";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./SpecializedCoursesCarousel.css";

// Custom Previous Arrow
const PrevArrow = ({ onClick }) => (
  <button className="custom-arroww prev-arrow" onClick={onClick}>
    &#10094;
  </button>
);

// Custom Next Arrow
const NextArrow = ({ onClick }) => (
  <button className="custom-arroww next-arrow" onClick={onClick}>
    &#10095;
  </button>
);

const SpecializedCoursesCarousel = ({
  title,
  subtitle,
  courses,
  seeAllLink = "#",
  slidesToShow = 2
}) => {
  const location = useLocation();
  const showSeeAll = location.pathname.includes("/destinations");

 const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow,
  slidesToScroll: 1,
  autoplay: true,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1024, // tablets
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 768, // small tablets
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 600, // mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
};

  return (
    <section className="courses-section container">
      <div className="courses-header">
        <h2>{title}</h2>
        {showSeeAll && (
          <a href={seeAllLink} className="see-all">See all</a>
        )}
      </div>

      {subtitle && <p className="courses-subtext">{subtitle}</p>}

      <Slider {...settings}>
        {courses.map((course, index) => (
          <div key={index} className="course-card">
            <img src={course.img} alt={course.title} className="course-img" />
            <p className="course-desc">
              <strong>{course.title}</strong> – {course.desc}
            </p>
          </div>
        ))}
      </Slider>

      {showSeeAll && (
        <p className="courses-footer">
          These programs not only offer world-class education but also open <br/> doors to jobs in America across industries.
        </p>
      )}
    </section>
  );
};

export default SpecializedCoursesCarousel;
